export default __webpack_public_path__ + "static/media/tgv-site-top.1712bbeb.png";